import React from "react";

function Row({ children, isHeaderOrFooter = false, ...props }) {
  const { className, ...rest } = props;
  // Rediseño: filas intercaladas para marcar la frontera de cada línea y resaltado celeste al pasar el mouse
  const sClassName = isHeaderOrFooter
    ? null
    : [
      "border-b border-line dark:border-line-dark last:border-b-0",
      "bg-white even:bg-gray-50 dark:bg-gray-800 dark:even:bg-gray-700/40",
      "hover:bg-primary-50 dark:hover:bg-gray-700",
      "transition-colors duration-75",
      className || "",
    ].join(" ");

  return (
    <>
      <tr {...rest} className={sClassName}>
        {children}
      </tr>
    </>
  );
}

Row.displayName = "Table.Row";

export default Row;
